<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="filteredShiftList || []"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("setup.label.UserWorkingShift") }}
                    </div>
                    <div class="mr-2 mb-1 order-1" style="">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="
                          $router.push({ name: 'Create User Working Shift' })
                        "
                        size="small"
                        color="primary"
                        >{{
                          $t("setup.label.CreateUserWorkingShift")
                        }}</vs-button
                      >
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                    <vs-th>{{ $t("setup.label.TeamName") }}</vs-th>
                    <vs-th>{{ $t("setup.label.Shift") }}</vs-th>
                    <vs-th>{{ $t("setup.label.UserName") }}</vs-th>
                    <vs-th class="tHeadCenter">{{
                      $t("setup.label.Actions")
                    }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="shiftList"
                      v-for="(shiftList, index) in data"
                    >
                      <vs-td>{{ shiftList.id }}</vs-td>
                      <vs-td>{{ shiftList.teamCode }}</vs-td>
                      <vs-td>{{ shiftList.shiftName }}</vs-td>
                      <vs-td>{{ shiftList.userName }}</vs-td>
                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <!-- <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 stroke-current cursor text-primary"
                            @click.stop="viewShift(shiftList)"
                            class="icon_row"
                          /> -->
                          <feather-icon
                            icon="EditIcon"
                            title="edit"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editShift(shiftList)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="TrashIcon"
                            title="delete"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            @click.stop="
                              delId = shiftList.id;
                              toggleTeam = false;
                              deleteTicketPopup = true;
                            "
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <delete-popup
          :deletePopup="deleteTicketPopup"
          title="User Working Shift"
          @deletePressed="deleteTicket(delId)"
          @cancelPressed="deleteTicketPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import DeletePopup from "@/components/DeletePopup.vue";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTeam: false,
      descriptionItems: [5, 10, 15],
      deleteTicketPopup: false,
      delId: 0,
      activeTab: 0,
      pages1: [
        { name: "Team", active: "active" },
        { name: "Team User", active: "inactive" },
      ],
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
  },

  computed: {
    ...mapState({
      shiftList: (state) => state.teams.shiftList,
    }),
    filteredShiftList() {
      const seen = new Set();
      return this.shiftList.filter((item) => {
        const key = `${item.userId}_${item.shiftName}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
  },
  methods: {
    viewShift(item) {
      this.$router.push({
        name: "View User Working Shift",
        params: { id: item.id, name: item.teamCode },
      });
    },

    async getTeamUserList() {
      this.loading = true;
      try {
        this.$store.dispatch("teams/setShiftData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editShift(shiftList) {
      this.$router.push({
        name: "Edit User Working Shift",
        params: { teamId: shiftList.teamId, shiftId: shiftList.shiftId },
      });
    },

    async deleteTicket(id) {
      this.deleteTicketPopup = false;
      try {
        await this.$store.dispatch("teams/deleteShiftMappingAction", id);
        await this.getTeamUserList();
        this.$toasted.success("Successfully Deleted", {
          duration: 2000,
        });
      } catch (error) {
        this.$toasted.error("Something Went Wrong", {
          duration: 2000,
        });
      }
    },
  },

  mounted() {
    this.getTeamUserList();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
